import RejectedFilterModal from '../ui/RejectedFilterModal.vue';
import {
  buildRejectedListUrlQuery,
  countActiveRejectedFilters,
  parseRejectedListFilters,
  parseRejectedListSort,
  toRejectedListSort,
} from '../lib/rejected-list-query';
import type { RejectedListFilters, RejectedListSort } from '../lib/rejected-list-query';
import type { ListRejectedMatricesParams } from '../api/matrices.api';
import { useListControls } from './useListControls';
import type { ListControlsOptions } from './useListControls';

type RejectedListRequestParams = Pick<
  ListRejectedMatricesParams,
  'sort' | 'order' | 'rejectedAt' | 'createdBy' | 'revision'
>;

export function useRejectedListControls(options: ListControlsOptions) {
  return useListControls<RejectedListSort, RejectedListFilters, RejectedListRequestParams>(
    {
      filterModal: RejectedFilterModal,
      parseSort: parseRejectedListSort,
      parseFilters: parseRejectedListFilters,
      toSort: toRejectedListSort,
      pickFilters: ({ rejectedAt, createdBy, revision }) => ({ rejectedAt, createdBy, revision }),
      countFilters: countActiveRejectedFilters,
      buildUrlQuery: buildRejectedListUrlQuery,
      toRequestParams: (sortState, filters) => ({
        sort: sortState.sort || undefined,
        order: sortState.order || undefined,
        rejectedAt: filters.rejectedAt,
        createdBy: filters.createdBy,
        revision: filters.revision,
      }),
    },
    options
  );
}
